module.exports = ".modal {\n  margin-top: 0px !important; }\n"